import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
//import { ThemeSwitchService } from 'app/services/theme.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import {
    FuseConfig,
    FuseConfigService,
    Scheme
} from '@fuse/services/config';
import { Subject, takeUntil } from 'rxjs';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { ThemeService } from 'app/layout/common/themeswitch/theme.service';




@Component({
  selector: 'themeswitch',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonToggleModule,
	MatIconModule,
	CommonModule
  ],
  templateUrl: './themeswitch.component.html',
  styleUrl: './themeswitch.component.scss'
})
export class ThemeSwitchComponent {
	isDarkMode = { darkMode: false };
    config: FuseConfig;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    schemeIndex = 0; // 0: Auto, 1: Light, 2: Dark

    constructor(
        //private themeSwitchService: ThemeSwitchService,
        private _fuseConfigService: FuseConfigService,
        private themeService: ThemeService
    ) {}

    ngOnInit(): void {
        // //this.themeService.apply();
        this.isDarkMode = this.themeService.getLocalStorageItem("theme");
        console.log('isDarkMode:', this.isDarkMode);
        if (this.isDarkMode.darkMode != null && this.isDarkMode.darkMode) {
            this.setScheme('dark');
            this.themeService.setDarkMode();
        }
        else {
            this.setScheme('light');
            this.themeService.setLightMode();
        }

        // Subscribe to config changes
        this._fuseConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config: FuseConfig) => {
                // Store the config
                this.config = config;
            });
    }

    onSchemeChange(): void {
        this.setScheme(this.config.scheme);
        if (this.config.scheme == 'dark') {
            this.themeService.setDarkMode();
        }
        else {
            this.themeService.setLightMode();
        }
      }

      toggleTheme() {
        this.config.scheme = this.config.scheme === 'light' ? 'dark' : 'light';
        this.onSchemeChange();
      }
      

    /**
     * Set the scheme on the config
     *
     * @param scheme
     */
    setScheme(scheme: Scheme): void {
        console.log('settingscheme:', scheme);
        this._fuseConfigService.config = { scheme };
    }
}
